"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "stella-cilento": {
    "59c30492": [{
      "hkey": "9e36de93",
      "slug": "drodo-cavallo-mauro",
      "name": "Drodo-Cavallo Mauro",
      "primary": true,
      "skipSearch": false
    }],
    "droro": [{
      "hkey": "9e36de93",
      "slug": "drodo-cavallo-mauro",
      "name": "Drodo-Cavallo Mauro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;